import * as React from "react"
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip"

interface SimpleTooltipProps {
  content: React.ReactNode;
  children: React.ReactElement;
  side?: "top" | "bottom" | "left" | "right";
  delayDuration?: number;
}

export const SimpleTooltip = React.forwardRef<
  HTMLButtonElement | HTMLDivElement,
  SimpleTooltipProps
>(({ content, children, side, delayDuration }, ref) => {
  if (!content) return children;

  // Clone the child to forward the ref
  const childWithRef = React.cloneElement(children, {
    ref,
  } as any);

  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger asChild>{childWithRef}</TooltipTrigger>
      <TooltipContent side={side}>{content}</TooltipContent>
    </Tooltip>
  );
});

SimpleTooltip.displayName = "SimpleTooltip";
